import React, {useEffect} from "react";
import {useAuth} from "react-oidc-context";
import {Redirect, useHistory} from "react-router-dom";
import ApiClient from "../services/ApiClient";

export default function AuthCallbackPage() {
  const auth = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (auth.isAuthenticated) {
      const returnTo = (auth.user?.state as { returnTo?: string })?.returnTo ?? "/";
      ApiClient.setAccessTokenProvider(() => auth.user?.access_token)
      history.replace(returnTo);
    }
  }, [auth.isAuthenticated, auth.user, history]);

  if (auth.error) {
    if (auth.error.message === "Session not active") {
      return <Redirect to="/dashboard" />;
    }
    return <div>Error: {auth.error.message}</div>;
  }

  return <div>Signing you in…</div>;
}